import GenericTable from "@/components/generics/genericTable/GenericTable.vue";
import StatsModal from "@/components/stats/StatsModal.vue";

export default {
  name: "mixinStats",
  components: {
    GenericTable,
    StatsModal,
  },
  data() {
    return {
      endpointUrl: "/statistique",
      namespaceTab: "",
      cols: [
        { key: "date_creation", overrideName: "Créée le", defaultOrder: true },
        { key: "user_created__username", overrideName: "Créée par" },
        { key: "nom" },
        { key: "date_start" },
        { key: "date_end" },
      ],
      filterableCol: ["nom"],
    };
  },
  methods: {
    /**
     * Affiche la modale de la statistique avec ses détails.
     * @public
     * @param {Object} stat Statistique sélectionnée.
     * @param {Object} namespace Namespace du tableau.
     * @param {Object} type Type de la statistique.
     * @param {Object} sousType Sous-type de la statistique.
     */
    openDetails(stat, namespace, type, sousType) {
      this.namespaceTab = namespace;

      this.$modal.show("stats", {
        stat,
        type,
        sousType,
      });
    },
    /**
     * Définit les actions du tableau des statistiques en question.
     * @public
     * @param {String} namespace Namespace du tableau.
     * @return {Array}
     */
    getActions(namespace) {
      const actions = [{ title: "Ajouter", callback: "add" }];

      if (
        this.$store.state[namespace]
        && this.$store.state[namespace].displayArchived
      ) {
        actions.push({ title: "Désarchiver", callback: "unarchive" });
      } else {
        actions.push({ title: "Supprimer", callback: "delete" });
      }

      return actions;
    },
    /**
     * Exécute les actions du tableau des statistiques en question.
     * @public
     * @param {String} actionCode Action sélectionnée.
     * @param {Object} refGenericTable Référence (ref) du tableau.
     * @param {Object} namespace Namespace du tableau.
     * @param {Object} type Type de la statistique.
     * @param {Object} sousType Sous-type de la statistique.
     */
    dispatchAction(actionCode, refGenericTable, namespace, type, sousType) {
      // On execute le dispatch générique qui gère le delete
      const resCode = this.$refs[refGenericTable].genericDispatch(
        actionCode,
        namespace,
        this.endpointUrl,
        "une statistique",
      );

      if (resCode === -1) {
        // Le genericDispatch n'a rien fait (actionCode non géré)
        switch (actionCode) {
          case "add":
            this.namespaceTab = namespace;

            this.$modal.show("stats", {
              new: true,
              type,
              sousType,
            });
            break;

          default:
            break;
        }
      }
    },
  },
};
